<script>
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import validation from "../../../helpers/validation";
import axios from "axios";
import {slugify} from "@/state/helpers";
import ErrorAlert from "@/components/errorAlert";
import AccountForm from "@/components/accountForm";
import PhoneSelect from "../../../components/phoneSelect";

export default {
  page: {
    title: "Initial profile setup",
    meta: [{ name: "description", content: '' }],
  },
  components: {
    PhoneSelect,
    AccountForm,
    Layout,
    ErrorAlert,
    Multiselect,
  },
  created() {
    this.initializeFieldsFromState();
  },
  data() {
    return {
      title: "Initial profile setup",
      showModal: false,
      items: [
        {
          text: "Initial profile setup",
          active: true
        },
      ],
      registeredAs: 'company',
      companyForms: {
        personalInfo: {
          name: 'Company Info',
          fields: {
            company_name: {
              name: 'Full company name',
              value: '',
              required: true,
              error: false,
            },
            vat_number: {
              name: 'VAT number',
              value: '',
              required: true,
              error: false
            },
            company_number: {
              name: 'Registration number',
              value: '',
              required: true,
              error: false
            },
            taxpayer: {
              name: 'VAT (PDV)',
              value: true,
              type: 'radio',
              required: true,
              error: false
            },
            country: {
              name: 'Country',
              value: '',
              options: ['Serbia', 'Bosnia and Herzegovina', 'Slovenia', 'Croatia', 'Montenegro', 'Macedonia'],
              type: 'select',
              error: false,
            },
            city: {
              name: 'City',
              value: '',
              required: true,
              error: false,
            },
            postal_code: {
              name: 'Postal code',
              value: '',
              required: true,
              error: false,
            },
            street_address: {
              name: 'Street address',
              value: '',
              required: true,
              error: false
            },
            phone_number: {
              name: 'Phone',
              value: '',
              type: 'phone',
              required: true,
              error: false,
            },
          }
        },
        bankingInfo: {
          name: 'Banking info',
          fields: {
            bank: {
              name: 'Bank',
              value: '',
              required: true,
              error: false,
            },
            bank_account_number: {
              name: 'Bank account number',
              value: '',
              required: true,
              error: false,
              placeholder: 'ex. 200000000012345600',
              autocomplete: 'cc-number'
            }
          },
        },
      },
      // Not used actually
      individualForms: {
        personalInfo: {
          name: 'Personal Info',
          fields: {
            name: {
              name: 'Full name',
              value: '',
              required: true,
              error: false,
            },
            unique_personal_identification_number: {
              name: 'Unique Personal Identification Number (JMBG)',
              value: '',
              required: true,
              error: false,
            },
            gender: {
              name: 'Gender',
              value: '',
              options: ['male', 'female'],
              type: 'select',
              error: false,
            },
            country: {
              name: 'Country',
              value: '',
              options: ['Serbia', 'Bosnia and Herzegovina', 'Slovenia', 'Croatia', 'Montenegro', 'Macedonia'],
              type: 'select',
              error: false,
            },
            city: {
              name: 'City',
              value: '',
              required: true,
              error: false,
            },
            postal_code: {
              name: 'Postal code',
              value: '',
              required: true,
              error: false,
            },
            street_address: {
              name: 'Street address',
              value: '',
              required: true,
              error: false
            },
            phone_number: {
              name: 'Phone',
              value: '',
              type: 'phone',
              required: true,
              error: false,
            },
          }
        },
        bankingInfo: {
          name: 'Banking info',
          fields: {
            bank: {
              name: 'Bank',
              value: '',
              required: true,
              error: false,
            },
            bank_account_number: {
              name: 'Bank account number',
              value: '',
              required: true,
              error: false,
              placeholder: 'ex. 200000000012345600',
              autocomplete: 'cc-number'
            }
          },
        },
      }
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    currentTab() {
      return this.$route.params.tab;
    },
    selectedFormsName() {
      return this.registeredAs + 'Forms';
    },
    selectedForms() {
      return this[this.selectedFormsName];
    },
  },
  methods: {
    async onChangedTab(newTabIndex, prevTabIndex, bvEvent) {
      if (!this.validateForms()) {
        bvEvent.preventDefault();
      }
    },
    initializeFieldsFromState() {
      this.$store.commit('errorBag/CLEAR');

      this.registeredAs = this.user.registered_as ? this.user.registered_as : 'company';

      // eslint-disable-next-line no-unused-vars
      for (let [formKey, formValue] of Object.entries(this.selectedForms)) {
        for (let [inputKey, inputValue] of Object.entries(formValue.fields)) {
          inputValue.value = this.user[inputKey];
        }
      }
    },
    async complete () {
      this.$store.commit('errorBag/CLEAR');

      for (let form in this.selectedForms) {
        this.validate(form)
      }

      try{
        this.$store.commit('loader/START_LOADING');

        const requestData = {
          registered_as: this.registeredAs,
        }

        // eslint-disable-next-line no-unused-vars
        for (let [formKey, formValue] of Object.entries(this.selectedForms)) {
          for (let [inputKey, inputValue] of Object.entries(formValue.fields)) {
            requestData[inputKey] = inputValue.value
          }
        }

        const { data } = await axios.put('/profile', requestData);
        this.$store.commit('user/SET_USER', data);

        this.$router.push({name: this.$store.getters['user/homeRouteName']});
      } catch (error) {
        // eslint-disable-next-line no-empty
      } finally{
        this.$store.commit('loader/END_LOADING');
      }
    },
    cancel() {
      this.initializeFieldsFromState();
    },
    validateForms() {
      let isValid = true
      for (let form in this.selectedForms) {
        isValid = isValid && this.validate(form);
      }

      return isValid;
    },
    validate(formName) {
      let isValid = true;
      let fields = this.selectedForms[formName].fields;
      for (let field in this.selectedForms[formName].fields) {

        // check if field is empty
        if(fields[field].required && fields[field].value === '') {
          fields[field].error = true;
          isValid = false;
        }

        // check special type of fields
        if(fields[field].type && validation[fields[field].type] !== undefined) {
          if(!validation[fields[field].type](fields[field].value)) {
            fields[field].error = true;
            isValid = false;
          }
        }
      }

      return isValid
    },
    slugify: slugify,
  }
};
</script>

<template>

  <Layout>
    <div class="row">
      <div class="col-12 offset-xl-2 col-xl-8 mb-5 pb-4">
        <div class="card">
          <div class="card-body">
            <ErrorAlert/>
            <b-tabs nav-class="nav-tabs-custom" content-class="text-muted" @activate-tab="onChangedTab">
              <b-tab :title="form.name" v-for="(form, key)  in selectedForms" :key="key" :active="currentTab === slugify(form.name)">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i :class="form.icon"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{ form.name }}</span>
                </template>

                <div class="p-3 mt-4">
                  <h3 class="mb-4">{{ form.name }}</h3>
                  <div class="row">
                    <div class="col-12">
                      <form :ref="form.name" autocomplete="on" @submit.prevent="complete">
<!--                        <div v-if="key === 'personalInfo'" class="form-group row mb-3">-->
<!--                          <label class="col-12 col-md-5 col-form-label">Registered as</label>-->
<!--                          <div class="col-12 col-md-7">-->
<!--                            <multiselect  v-model="registeredAs"-->
<!--                                          :options="['company', 'individual']"-->
<!--                                          :allow-empty="false"-->
<!--                                          deselectLabel=""-->
<!--                                          class="text-capitalize"-->
<!--                                          :multiple="false">-->
<!--                              <template slot="option" slot-scope="props">-->
<!--                                <div class="text-capitalize option__desc"><span class="option__title">{{ props.option }}</span></div>-->
<!--                              </template>-->
<!--                            </multiselect>-->
<!--                          </div>-->
<!--                        </div>-->
                        <div v-for="(field, fieldKey) in form.fields" :key="fieldKey"
                             class="form-group row mb-3">
                          <label class="col-12 col-md-5 col-form-label" :for="fieldKey">{{ field.name }}:</label>
                          <div class="col-12 col-md-7">
                            <b-form-radio-group class="mb-2" v-if="field.type === 'radio'" v-model="field.value">
                              <b-form-radio :value="true" class="mb-1">Yes</b-form-radio>
                              <b-form-radio :value="false" class="mb-1">No</b-form-radio>
                            </b-form-radio-group>
                            <multiselect  v-else-if="field.type === 'select'"
                                          class="text-capitalize"
                                          :class="{ invalid: field.error }"
                                          v-model="field.value"
                                          :options="field.options"
                                          :allow-empty="false"
                                          deselectLabel=""
                                          @input="field.error = false"
                                          :multiple="false">
                              <template slot="option" slot-scope="props">
                                <div class="text-capitalize option__desc"><span class="option__title">{{ props.option }}</span></div>
                              </template>
                            </multiselect>
                            <phone-select
                                v-else-if="field.type === 'phone'"
                                v-model="field.value"
                                @input="field.error = false"
                                :field="field" ></phone-select>
                            <input
                                v-else
                                :id="fieldKey"
                                type="text"
                                class="form-control"
                                @input="field.error = false"
                                :class="{'is-invalid': field.error}"
                                :name="field.name.toLowerCase()"
                                :placeholder="field.placeholder"
                                v-model="field.value"
                            />
                          </div>
                        </div>

                        <div class="text-right mt-4">
                          <b-button type="button" variant="secondary" @click="cancel()">Cancel</b-button>
                          <b-button type="submit" variant="primary" class="ml-2" >Save</b-button>
                        </div>
                      </form>
                    </div>
                    <!-- end col -->
                  </div>
                </div>
              </b-tab>

              <b-tab title="Account" :active="currentTab === 'account'">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-user-circle"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Account</span>
                </template>

                <div class="p-3 mt-4">
                  <h3 class="mb-4">My account</h3>

                  <AccountForm @accountDataUpdate="complete" @accountDataUpdateCancel="cancel"></AccountForm>

                </div>
              </b-tab>

            </b-tabs>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
  </Layout>
</template>
